import { Link } from "react-router-dom";
import { AppRoutesUI } from "../../config/appRoutes";
import { ActionUI, useAppDispatch } from "../../core/redux";
import MenuIcon from "@rsuite/icons/Menu";
import { UserDropDown } from './userDropdown.component';
import { useState, useEffect } from "react";

export const TopNav = () => {
  const dispatch = useAppDispatch();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1200);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1200);
      dispatch(ActionUI.closeSideNav());
    };

    window.addEventListener("resize", handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    !isMobile ? (
    <div className="bg-primary-grey top-nav ps-1 py-2 d-flex align-items-center justify-content-between">
      <div className="d-flex flex-row">
      <button
        className="site-nav-toggle btn px-3 ms-1 me-1"
        onClick={(_) => dispatch(ActionUI.openSideNav())}
      >
        <MenuIcon
          onClick={(_) => {
            dispatch(ActionUI.handleShowSiteNav());
            dispatch(ActionUI.openSideNav());
          }}
        />
      </button>
      <Link
        to={AppRoutesUI.Root}
        className="text-gray text-decoration-none top-nav-title col-11"
      >
        <h3>ReganalyticsAuth</h3>
      </Link>
      </div>
      <div className="d-flex me-2">
        <UserDropDown/>
      </div>
    </div>
    ) : (
      <div className="bg-primary-grey top-nav ps-1 py-2 d-flex align-items-center justify-content-between">
      <div className="d-flex flex-row">
      <button
        className="site-nav-toggle btn px-3 ms-1 me-1"
        onClick={(_) => dispatch(ActionUI.openSideNav())}
      >
        <MenuIcon
          onClick={(_) => {
            dispatch(ActionUI.handleShowSiteNav());
            dispatch(ActionUI.openSideNav());
          }}
        />
      </button>
      <Link
        to={AppRoutesUI.Root}
        className="text-gray text-decoration-none top-nav-title col-11"
      >
        <h3>ReganalyticsAuth</h3>
      </Link>
      </div>
    </div>
    )
  );
};
